import { render, staticRenderFns } from "./VesselHistory.vue?vue&type=template&id=230b2304&scoped=true&"
import script from "./VesselHistory.vue?vue&type=script&lang=js&"
export * from "./VesselHistory.vue?vue&type=script&lang=js&"
import style0 from "./VesselHistory.vue?vue&type=style&index=0&id=230b2304&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230b2304",
  null
  
)

export default component.exports